import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { ui } = constants.colors;
const { mediaQuery: breakpoint } = mediaQueryStyles;
const { textSObj, textMObj, heading3Obj, heading4Obj } = typographyStyles;

export const headingCss = (isContentSettingsPage) => {
  const cssToReturn = {
    color: ui.neutral[600],
    [breakpoint.upTo(constants.breakpoints.BreakpointNames.xs)]: {
      fontSize: "1.25rem",
    },
    ...typographyStyles.fontFamily.circular,
  };

  return isContentSettingsPage
    ? { ...heading4Obj, ...cssToReturn }
    : { ...heading3Obj, ...cssToReturn };
};

export const descriptionCss = (isContentSettingsPage) => {
  const cssToReturn = {
    marginBottom: 24,
  };

  return isContentSettingsPage
    ? { ...cssToReturn, marginTop: -10, ...textMObj }
    : { ...cssToReturn, marginTop: -12, ...textSObj };
};
